import WebServiceRequest from "../../../Api/WebServiceRequest";

class PhysicalCategoriesCreate extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("PhysicalCategory/Create");
  }
  setParams(data) {
    super.setRequestParamDataObj(data);
  }
}
export default PhysicalCategoriesCreate;
